import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Logs X-Error-* headers from API error responses.
 */
export const errorHeadersInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        const h = err.headers;
        const payload = {
          status: err.status,
          url: req.url,
          id:   h.get('X-Error-Id')   ?? '-',
          file: h.get('X-Error-File') ?? '-',
          line: h.get('X-Error-Line') ?? '-',
          hint: h.get('X-Error-Hint') ?? (err.error?.data?.developerMessage ?? err.message),
        };

        console.error('[API ERROR]', payload);
      }
      return throwError(() => err);
    })
  );
